import styled from 'styled-components'
import { H } from '@farewill/ui'
import { COLOR, GTR } from '@farewill/ui/tokens'

import Switch from 'components/switch'
import Tooltip from 'components/tooltip'

export type SectionToggle = {
  name: string
  isOn: boolean
  onToggle: () => void
  disabled?: boolean
}

const StyledHeadingRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${GTR.M};
  margin-bottom: ${GTR.S};
`

type Props = {
  heading: string
  toggle?: SectionToggle
}

const SectionHeading = ({ heading, toggle }: Props) => {
  if (!toggle) return <H size="S">{heading}</H>

  const handleToggle = () => {
    if (!toggle.disabled) toggle.onToggle()
  }

  const switchElement = (
    <Switch
      isOn={toggle.isOn}
      handleToggle={handleToggle}
      disabled={toggle.disabled}
      label={heading}
      testId={toggle.name}
    />
  )

  return (
    <StyledHeadingRow>
      {toggle.disabled ? (
        <Tooltip content="To turn off this section please delete the data within it.">
          {switchElement}
        </Tooltip>
      ) : (
        switchElement
      )}
      <H
        size="S"
        margin={0}
        color={toggle.isOn ? undefined : COLOR.GREY.MEDIUM}
      >
        {heading}
      </H>
    </StyledHeadingRow>
  )
}

export default SectionHeading
